import { useQuery } from "@tanstack/react-query";
import React from "react";
import useExamRoomActions from "../../../../api/hooks/admin/examRoom";
import { testRoomSnState } from "recoil/auth";
import { dateFormat } from "../../../../utils";
import Banner from "../../../modules/layout/Banner";
import Table from "../../../modules/layout/Table";
import SendMailModal from "./SendMailModal";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { useState } from "react";
import Select from "../../../atoms/input/Select";
import { emailState } from "../../../../static";
// 관리자-시험실-메일전송탭

const MailTab = () => {
  const { fetchSendMailList } = useExamRoomActions();
  const RoomSn = useRecoilValue(testRoomSnState);

  const [mailUserSn, setMailUserSn] = useState(0);
  const { getRoomCnt } = useExamRoomActions();
  const { data: roomCnt } = useQuery({
    queryKey: ["getRoomCnt", RoomSn],
    queryFn: () => getRoomCnt({ room_sn: RoomSn }),
  });

  const [sendEmailType, setSendEmailType] = useState("");
  const {
    data: sendMailList,
    refetch,
    isLoading,
  } = useQuery({
    queryKey: ["fetchSendMailList", sendEmailType],
    queryFn: () =>
      fetchSendMailList({
        sendType: 1,
        room_sn: RoomSn,
        typefilter: sendEmailType,
      }),
  });

  // console.log(RoomSn);
  // console.log(sendMailList);

  return (
    <div className="tab-content">
      <div className="tab-pane">
        <Banner
          properties={["시험요청", "응시대기", "응시완료", "응시중단"]}
          data={[
            roomCnt?.data?.applicator,
            roomCnt?.data?.testring,
            roomCnt?.data?.done,
            sendMailList?.data?.abortment_opic_tester,
          ]}
          icons={["request", "wait", "complete", "stop"]}
        />
        <div className="flex filtering">
          <div className="tab-title">
            <p>메일전송 내역</p>
          </div>
          <div>
            <div className="dropdown content1-dropdown">
              {/* <button
                className="btn btn-secondary dropdown-toggle dropdown-btn"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                전체
                <span></span>
              </button> */}
              <Select
                options={emailState}
                onChange={(e) => {
                  setSendEmailType(e.target.value);
                }}
              ></Select>
              <ul className="dropdown-menu">
                <li>
                  <a className="dropdown-item" href="#">
                    발송성공
                  </a>
                </li>
                <li>
                  <a className="dropdown-item" href="#">
                    발송실패
                  </a>
                </li>
              </ul>
            </div>
            <input
              type="text"
              className="search-input"
              placeholder="수신자 이름, 메일주소"
            />
            {/* <button
              className="btn-custom b-btn input-btn"
              onClick={() => refetch()}
            >
              검색
            </button> */}
          </div>
        </div>
        <div className="tableFixHead table-responsive">
          <div className="overflow-scroll height-300">
            <Table
              isLoading={isLoading}
              className="roomtable-content3"
              header={[
                "No.",
                "발송일시",
                // "발송자",
                "수신자",
                "이름",
                // "시험코드",
                // "수험번호",
                "발송상태",
                "발송내용",
              ]}
            >
              {sendMailList?.data?.map((tester) => {
                return (
                  <tr key={tester?.sn}>
                    <td>{tester?.sn}</td>
                    <td>{dateFormat(tester?.sendTime)}</td>
                    {/* <td>{tester?.sender}</td> */}
                    <td>{tester?.email}</td>
                    <td>{tester?.name}</td>
                    {/* <td>{tester?.tester_code}</td> */}
                    {/* <td></td> */}
                    <td>
                      {tester?.isSuccess === 1 ? (
                        <>
                          <span className="circle success" />
                          성공
                        </>
                      ) : (
                        <>
                          <span className="circle fail" />
                          실패 <br></br> {tester?.result}
                        </>
                      )}
                    </td>
                    <td>
                      <button
                        type="button"
                        className="view-modalbtn"
                        onClick={() => {
                          setMailUserSn(tester.receiver_applicator_sn);
                          setTimeout(() => {
                            setMailUserSn(0);
                          }, 100);
                        }}
                      >
                        보기
                      </button>
                    </td>
                  </tr>
                );
              })}
              {sendMailList?.data.length === 0 && (
                <tr>
                  <td colSpan={6}>데이터가 없습니다.</td>
                </tr>
              )}
            </Table>
            <SendMailModal mailUserSn={mailUserSn} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MailTab;
